export const UPDATE_COMMENT_BY_RESULT_FAILURE = 'UPDATE_COMMENT_BY_RESULT_FAILURE';

export const updateCommentByResultFailure = error => ({
    type: UPDATE_COMMENT_BY_RESULT_FAILURE,
    payload: error,
    error: true,
});
